import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TEST_COMPLETE, TEST_QUESTIONS } from "../../util/constants";
import { getNoCacheCall, postCall } from "../../util/resources";
import SesHeader from "../header";
import {
    CommonLoader,
    CommonPopup,
    QuesLoader,
    CommonQuesProgress,
    useScreenTransition,
    useTimer,
    redirectToAssessmentSummary,
} from "../../util/common";
import { BaseContext } from "../../App";

const TestTaker = () => {
    const [test, setTest] = useState();
    const [selectedAns, setSelectedAns] = useState(-1);
    const [popupData, setpopupData] = useState({
        isOpen: false,
        popupHeader: "",
        popupBody: "",
        popupFooter: "",
    });
    const { startTimer, stopTimer } = useTimer();

    const location = useLocation();
    const { phase, loading, startTransition, done } = useScreenTransition();
    const phrases = location.state.user.siteConfig.phrases;
    const navigate = useNavigate();
    const formRef = useRef();
    const quesNo = useRef(-1);
    const attachKeyListenRef = useRef();
    const keyMappings = useRef({});
    const header = useRef({
        "x-xpert-session": location.state.user.sessionId,
        "Content-Type": "application/json",
    });

    const changeSelectedAns = (e) => {
        setSelectedAns(e.target.value);
    };

    const detectKeyDown = (e) => {
        e.preventDefault();
        if (!loading) {
            if (e.code in keyMappings.current) {
                setSelectedAns(keyMappings.current[e.code]);
            }
            if (selectedAns !== -1 && e.code === "Space") {
                nextNavigate();
            }
        }
    };

    const nextNavigate = async () => {
        startTransition(
            async () => {
                const ansObj = { answers: [], structure: null, value: selectedAns };
                let quesObj = test.questions;
                quesObj[0].userAnswer = ansObj;
                const elapsedTime = stopTimer();
                const otherData = {
                    duration: location.state.test.duration + elapsedTime,
                };
                try {
                    let response;
                    if (test.lastPage) {
                        response = await postCall(
                            TEST_COMPLETE + location.state.test.id,
                            { ...otherData, questions: quesObj },
                            header.current
                        );
                        redirectToAssessmentSummary(location, navigate);
                    } else {
                        response = await postCall(
                            TEST_QUESTIONS + location.state.test.id,
                            { ...otherData, questions: quesObj },
                            header.current
                        );
                    }
                    if (response.data.status === true) {
                        if (test.lastPage) {
                            redirectToAssessmentSummary(location, navigate);
                        } else {
                            setSelectedAns(-1);
                            formRef.current.reset();
                            quesNo.current += 1;
                            await getQuestion();
                        }
                    }
                } catch (error) {
                    console.log(error);
                }
                done();
            },
        );
    };

    const getQuestion = async () => {
        try {
            const response = await getNoCacheCall(
                TEST_QUESTIONS + location.state.test.id + "/" + quesNo.current,
                header.current
            );
            setTest(response.data[0]);
            quesNo.current = response.data[0].startNumber;
            let key;
            keyMappings.current = {};
            response.data[0].questions[0].answers.map((val) => {
                key = `Digit${val.position + 1}`;
                keyMappings.current = {
                    ...keyMappings.current,
                    [key]: val.position,
                };
            });
            startTimer();
        } catch (error) {
            console.log();
        }
    };

    const exitTest = () => {
        setpopupData((prev) => {
            prev = {
                ...prev,
                isOpen: true,
                popupHeader: phrases?.["1002895"],
                popupBody: phrases?.["10022032"],
                popupFooter: phrases?.["14392"],
            };
            return prev;
        });
    };

    const closePopUp = () => {
        setpopupData((prev) => {
            prev = { ...prev, isOpen: false };
            return prev;
        });
    };

    const approveAction = async () => {
        const ansObj = { answers: [], structure: null, value: selectedAns };
        let quesObj = test.questions;
        quesObj[0].userAnswer = ansObj;
        const elapsedTime = stopTimer();
        const otherData = {
            duration: location.state.test.duration + elapsedTime,
            pause: true,
        };
        const response = await postCall(
            TEST_QUESTIONS + location.state.test.id,
            { ...otherData, questions: quesObj },
            header.current
        );
        navigate("/");
    };

    useEffect(() => {
        attachKeyListenRef.current?.focus({
            preventScroll: true,
        });
    }, [test]);

    useEffect(() => {
        getQuestion();
    }, []);

    if (!test) {
        return <CommonLoader />;
    }

    return (
        <>
            <div
                className="g-container flex_col p4 g5 pt0_mobile g2_mobile full-width"
                ref={attachKeyListenRef}
                tabIndex="-1"
                onKeyDown={detectKeyDown}
                onBlur={(e) =>
                    e.target.focus({
                        preventScroll: true,
                    })
                }
                style={{ outline: "none" }}
            >
                <SesHeader clientCobranding={location.state.cobrandingLink} />
                <CommonQuesProgress test={test} />
                <div className=" position_relative ">
                    <QuesLoader show={phase === "showing-loader"} />

                    <div className={`flex_col g2 shown ${phase}`}>

                        <h3>
                            {phrases?.["10022031"]} {test.questions[0].topicNumber}
                        </h3>
                        <div
                            className="base questionText"
                            dangerouslySetInnerHTML={{
                                __html: test.questions[0].topicInstruction,
                            }}
                        />
                    </div>
                    <p />
                    <form ref={formRef} className="flex_row flex_col_mobile g2">
                        <div className={`flex_col flex_gsb g2 shown ${phase}`}>
                            <div className="small-title">
                                {phrases?.["13106"]} {test.startNumber}
                            </div>
                            <div
                                className="base p4 roundness_1 border_tt82 full-height questionText"
                                dangerouslySetInnerHTML={{
                                    __html: test.questions[0].questionText,
                                }}
                            />
                        </div>
                        <div className={`flex_col flex_gsb g2 shown ${phase}`}>
                            <div className="small-title">{phrases?.["15138"]}</div>
                            <fieldset
                                aria-label="group-container"
                                className="radio-group-container"
                            >
                                <div className="radio-group base p4 roundness_1 border_tt82 full-height">
                                    {test.questions[0].answers.map((val, ind) => (
                                        <div
                                            key={test.startNumber + ind}
                                            className="radio-container"
                                        >
                                            <input
                                                id={`option-${ind}`}
                                                type="radio"
                                                name="tt82_options"
                                                value={val.position}
                                                onChange={changeSelectedAns}
                                                checked={
                                                    selectedAns == val.position
                                                }
                                            />
                                            <label
                                                dangerouslySetInnerHTML={{
                                                    __html: val.content,
                                                }}
                                                htmlFor={`option-${ind}`}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </fieldset>
                        </div>
                    </form>
                </div>
                <hr />
                <div className="flex_col_reverse_mobile flex_row align-items_center justify-content_between g2">
                    {test.lastPage ? (
                        <div />
                    ) : (
                        <button
                            className="button-secondary text_uppercase full-width_mobile"
                            onClick={exitTest}
                            disabled={loading}
                        >
                            {phrases?.["1002190"]}
                        </button>
                    )}
                    <button
                        className="button-primary text_uppercase full-width_mobile"
                        disabled={selectedAns === -1 || loading}
                        onClick={nextNavigate}
                    >
                        {test.lastPage
                            ? phrases?.["15140"]
                            : phrases?.["10976"]}
                    </button>
                </div>
            </div>
            <CommonPopup
                popupData={popupData}
                closeAction={closePopUp}
                approveAction={approveAction}
                setterFun={setpopupData}
            />
        </>
    );
};

export default TestTaker;
